import { ReportTypesNew } from 'models/ReportData';
import type { TimeModificator } from 'store/storeTypes';

type CustomTimeBoundary = 'start' | 'end';

export const getReportNavElementId = (report: ReportTypesNew | string): string => {
  return `report-nav-${report}-link`;
};

export const getReportNavElementIdFromPath = (path: string): string => {
  const report =
    path
      .split('/')
      .filter(Boolean)
      .pop() || path;

  return getReportNavElementId(report);
};

export const CUSTOM_DATE_RANGE_SUBMIT_ELEMENT_ID = 'custom-date-range-submit-button';

export const getCustomTimeSelectElementId = (boundary: CustomTimeBoundary): string => {
  return `custom-${boundary}-time-select`;
};

export const getCustomTimeHourElementId = (
  boundary: CustomTimeBoundary,
  hour: number
): string => {
  return `${getCustomTimeSelectElementId(boundary)}-hour-${hour}`;
};

export const getCustomTimeModificatorElementId = (
  boundary: CustomTimeBoundary,
  modificator: TimeModificator
): string => {
  return `${getCustomTimeSelectElementId(boundary)}-${modificator.toLowerCase()}-toggle`;
};

export const TIMELINE_DAY_VIEW_BUTTON_ELEMENT_ID = 'timeline-day-view-button';
export const TIMELINE_HOUR_VIEW_BUTTON_ELEMENT_ID = 'timeline-hour-view-button';
export const TIMELINE_PREVIOUS_HOUR_BUTTON_ELEMENT_ID = 'timeline-previous-hour-button';
export const TIMELINE_NEXT_HOUR_BUTTON_ELEMENT_ID = 'timeline-next-hour-button';
export const TIMELINE_HOUR_INPUT_ELEMENT_ID = 'timeline-hour-input';
export const TIMELINE_AM_PM_TOGGLE_ELEMENT_ID = 'timeline-am-pm-toggle';
export const TIMELINE_DAY_CHART_ELEMENT_ID = 'timeline-day-chart';
export const TIMELINE_DAY_CHART_BAR_ELEMENT_ID = 'timeline-day-chart-bar';
export const TIMELINE_WEEK_CHART_ELEMENT_ID = 'timeline-week-chart';

export const getJobAnalysisFilterElementId = (
  systemGroup: string,
  actionType: string
): string => {
  return `job-analysis-${systemGroup.toLowerCase()}-${actionType}-card`;
};

export const INK_CONSUMPTION_PER_JOB_BUTTON_ELEMENT_ID =
  'ink-consumption-per-job-download-button';

export const SYSTEM_ANALYSIS_REPORT_DOWNLOAD_BUTTON_ELEMENT_ID =
  'system-analysis-report-download-button';
export const SYSTEM_PAGE_ERROR_MAINTENANCE_DOWNLOAD_BUTTON_ELEMENT_ID =
  'system-page-error-maintenance-download-button';
export const SYSTEM_NICKNAME_INPUT_ELEMENT_ID = 'system-nickname-input';

export const DATE_PICKER_OPEN_BUTTON_ELEMENT_ID = 'date-picker-open-button';
export const MOBILE_DATE_PICKER_OPEN_BUTTON_ELEMENT_ID = 'mobile-date-picker-open-button';
export const DATE_PICKER_PREV_BUTTON_ELEMENT_ID = 'date-picker-prev-button';
export const DATE_PICKER_NEXT_BUTTON_ELEMENT_ID = 'date-picker-next-button';
export const TIMEFRAME_CUSTOM_BUTTON_ELEMENT_ID = 'timeframe-custom-button';

export const OVERVIEW_AVAILABILITY_CHART_ELEMENT_ID = 'overview-availability-chart';
export const OVERVIEW_PRODUCTION_CHART_ELEMENT_ID = 'overview-production-chart';

export const getOverviewSpeedChartElementId = (chartName: string): string => {
  return `overview-${chartName.toLowerCase()}-chart`;
};

export const JOB_ANALYSIS_INK_CONSUMPTION_CHART_ELEMENT_ID =
  'job-analysis-ink-consumption-chart';

export const getSystemPageTotalBottlesChartElementId = (
  systemGroup: string,
  mode: string
): string => {
  return `system-page-${systemGroup.toLowerCase()}-${mode}-total-bottles-chart`;
};

export const TV_DASHBOARD_PERFORMANCE_CHART_ELEMENT_ID =
  'tv-dashboard-performance-chart';

//*Production Hours (Working Hours settings page)
export const PRODUCTION_HOURS_SITE_SELECT_ELEMENT_ID = 'production-hours-site-select';
export const PRODUCTION_HOURS_APPLY_MODE_TOGGLE_ELEMENT_ID = 'production-hours-apply-mode-toggle';
export const PRODUCTION_HOURS_START_DATE_PICKER_ELEMENT_ID = 'production-hours-start-date-picker';
export const PRODUCTION_HOURS_VIEWING_SYSTEM_TYPE_SELECT_ELEMENT_ID =
  'production-hours-viewing-system-type-select';
export const PRODUCTION_HOURS_VIEWING_SITE_SELECT_ELEMENT_ID =
  'production-hours-viewing-site-select';
export const PRODUCTION_HOURS_SLOT_EDITOR_APPLY_BUTTON_ELEMENT_ID =
  'production-hours-slot-editor-apply-button';
export const PRODUCTION_HOURS_SLOT_EDITOR_CANCEL_BUTTON_ELEMENT_ID =
  'production-hours-slot-editor-cancel-button';
export const PRODUCTION_HOURS_SLOT_EDITOR_APPLY_DAYS_ELEMENT_ID =
  'production-hours-slot-editor-apply-days';
export const PRODUCTION_HOURS_DAY_ROW_SAVE_BUTTON_ELEMENT_ID = 'production-hours-day-row-save-button';
export const PRODUCTION_HOURS_DAY_ROW_CANCEL_BUTTON_ELEMENT_ID =
  'production-hours-day-row-cancel-button';
export const PRODUCTION_HOURS_SAVE_CHANGES_BUTTON_ELEMENT_ID =
  'production-hours-save-changes-button';
export const PRODUCTION_HOURS_DISCARD_BUTTON_ELEMENT_ID = 'production-hours-discard-button';

export const getProductionHoursSystemTypeToggleElementId = (systemGroup: string): string => {
  return `production-hours-system-type-${systemGroup.toLowerCase()}-toggle`;
};

//*Production Hours - Holidays modal
export const PRODUCTION_HOURS_MANAGE_HOLIDAYS_BUTTON_ELEMENT_ID =
  'production-hours-manage-holidays-button';
export const PRODUCTION_HOURS_HOLIDAYS_CALENDAR_CELL_ELEMENT_ID =
  'production-hours-holidays-calendar-cell';
export const PRODUCTION_HOURS_HOLIDAYS_SAVE_BUTTON_ELEMENT_ID =
  'production-hours-holidays-save-button';
export const PRODUCTION_HOURS_HOLIDAYS_CLOSE_BUTTON_ELEMENT_ID =
  'production-hours-holidays-close-button';
export const PRODUCTION_HOURS_HOLIDAYS_DELETE_REQUEST_BUTTON_ELEMENT_ID =
  'production-hours-holidays-delete-request-button';
export const PRODUCTION_HOURS_HOLIDAYS_DELETE_CONFIRM_BUTTON_ELEMENT_ID =
  'production-hours-holidays-delete-confirm-button';
export const PRODUCTION_HOURS_HOLIDAYS_DELETE_CANCEL_BUTTON_ELEMENT_ID =
  'production-hours-holidays-delete-cancel-button';
